<script lang="ts" setup>
import ErrorWrapper from "~/components/ErrorWrapper.vue";
import { useSeoStore } from "~/stores/useSeoStore";

const { getTitleErrorPage } = useSeoStore();
const error = useError()

useHead({
  title: getTitleErrorPage(),
});
</script>

<template>
  <NuxtLayout :name="'custom'">
    <ErrorWrapper :status-code="error?.statusCode" />
  </NuxtLayout>
</template>
